export default __webpack_public_path__ + "static/media/wlbg.b0cc8173.png";